
<template>
  <div class="appDashboard dashboard2">
    <div :class="{container:appConfig.container}">
      <app-header :title="title"></app-header>
    </div>
    <v-layout class="flex md12 ml-1" :class="{container:appConfig.container}" row wrap>
      <app-card class="md12 sm12 xs12 d-flex" :obj="{title}">
        <div slot="body">
          <v-layout style="position: absolute; left: 50px;">
            <v-btn
              depressed
              color="primary"
              :class="{disabled: isAutoUpdate}"
              v-on:click="onClickAutoUpdate"
            >
              {{ $t('CurrentStatus.AutoUpdate')}}
              <span v-if="isAutoUpdate">({{countDownTimer}})</span>
            </v-btn>
            <v-btn
              depressed
              color="primary"
              :disabled="!isAutoUpdate"
              v-on:click="onClickStopUpdate"
            >{{ $t('CurrentStatus.StopUpdate')}}</v-btn>
            <v-btn
              depressed
              color="primary"
              :class="{disabled: isAutoUpdate}"
              v-on:click="onClickUpdate"
            >{{ $t('CurrentStatus.ManualUpdate')}}</v-btn>
          </v-layout>
          <v-layout style="position: absolute; right: 50px;">
            <v-btn depressed class="v-btn v-btn--depressed theme--light info" v-on:click="onClickTop">{{ $t('CurrentStatus.GoToTop')}}</v-btn>
          </v-layout>

          <br>

          <h1 class="h1_style">SYSTEM STATUS</h1>

          <v-layout row wrap class="ml-3">
            <v-flex xs12 sys_style>
              <span>{{$t('SystemStatus.Time')}}：</span>
              <span>{{SystemStatusTime.substr(0,20)}}</span>
            </v-flex>
            <v-flex xs12 sys_style>
              <span>{{$t('SystemStatus.OnOff')}}：</span>
              <span>{{SystemStatusOnOff}}</span>
            </v-flex>
            <v-flex xs12 sys_style>
              <span>{{$t('SystemStatus.ACDC')}}：</span>
              <span v-if="SystemStatusACDC==1">ON</span>
              <span v-else-if="SystemStatusACDC==0">OFF</span>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-3">
            <v-flex xs12 sys_style>
              <span>{{$t('SystemStatus.Volt')}}：</span>
              <span>{{SystemStatusVolt}}V</span>
            </v-flex>
            <v-flex xs12 sys_style>
              <span>{{$t('SystemStatus.Current')}}：</span>
              <span>{{SystemStatusCurrent}}A</span>
            </v-flex>
            <v-flex xs12 sys_style>
              <span>{{$t('SystemStatus.Energy')}}：</span>
              <span>{{SystemStatusEnergy}}kW</span>
            </v-flex>
          </v-layout>

          <h1 class="h1_style">NiMH STATUS</h1>

          <v-data-table :headers="headers" :items="records" :rows-per-page-items="[50]" class="elevation-1" :loading="loading" item-key="serialNo" style="margin-top: 20px">

            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  style="padding-left: 4px"
                >
                  {{ header.text }}
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <tr>
                <td class="text-xs-left">{{ props.item.serialNo }}</td>
                <td class="text-xs-left">{{ props.item.rackVolt }}V</td>
                <td class="text-xs-left">{{ props.item.rackCurrent }}A</td>
                <td class="text-xs-left">
                  <span v-if="props.item.ihsStatus==1">ON</span>
                  <span v-else>OFF</span>
                </td>
                <td class="text-xs-left">
                  <span v-if="props.item.errorStatus.slice(-6).indexOf('1') == -1">正常</span>
                  <span style="color:red" v-if="props.item.errorStatus.slice(-1)==1">OVP　</span>
                  <span style="color:red" v-if="props.item.errorStatus.slice(-2,-1)==1">UVP　</span>
                  <span style="color:red" v-if="props.item.errorStatus.slice(-3,-2)==1">OCP　</span>
                  <span style="color:red" v-if="props.item.errorStatus.slice(-4,-3)==1">UCP　</span>
                  <span style="color:red" v-if="props.item.errorStatus.slice(-5,-4)==1">OTP　</span>
                  <span style="color:red" v-if="props.item.errorStatus.slice(-6,-5)==1">UTP</span>
                </td>
                <td class="text-xs-left">{{ props.item.unit1 }}V</td>
                <td class="text-xs-left">{{ props.item.unit2 }}V</td>
                <td class="text-xs-left">{{ props.item.unit3 }}V</td>
                <td class="text-xs-left">{{ props.item.unit4 }}V</td>
                <td class="text-xs-left">{{ props.item.unit5 }}V</td>
                <td class="text-xs-left">{{ props.item.unit6 }}V</td>
                <td class="text-xs-left">{{ props.item.unit7 }}V</td>
                <td class="text-xs-left">{{ props.item.temp1 }}℃</td>
                <td class="text-xs-left">{{ props.item.temp2 }}℃</td>
                <td class="text-xs-left">{{ props.item.temp3 }}℃</td>
                <td class="text-xs-left">{{ props.item.temp4 }}℃</td>
              </tr>
            </template>
          </v-data-table>

        </div>
      </app-card>
    </v-layout>
  </div>
</template>

<script>
import mediator from "../../components/common/mediator.vue";
import moment from "moment";
import locale from "../../utility/Locale";

export default {
  name: "NimhStatus",
  mixins: [mediator],

  mounted() {
    $(".appCard__header").remove();
    this.title = "SYSTEM & NiMH Status";

    setTimeout(() => {
      this.updateView();
      this.onClickAutoUpdate();
    }, this.$root.svgWaitingTime);
  },
  beforeDestroy() {
    clearInterval(this.$root.currentTimer);
  },
  data() {
    const $t = this.$t.bind(this);

    return {
      headers: [
        { text: $t("NiMHList.Columns.NiMHSerialNo"), value:"serialNo" },
        { text: $t("NiMHList.Columns.RackVolt"), value:"rackVolt" },
        { text: $t("NiMHList.Columns.RackCurrent"), value:"rackCurrent" },
        { text: $t("NiMHList.Columns.IhsStatus"), value:"ihsStatus" },
        { text: $t("NiMHList.Columns.ErrorStatus"), value:"errorStatus" },
        { text: $t("NiMHList.Columns.Unit1"), value:"unit1" },
        { text: $t("NiMHList.Columns.Unit2"), value:"unit2" },
        { text: $t("NiMHList.Columns.Unit3"), value:"unit3" },
        { text: $t("NiMHList.Columns.Unit4"), value:"unit4" },
        { text: $t("NiMHList.Columns.Unit5"), value:"unit5" },
        { text: $t("NiMHList.Columns.Unit6"), value:"unit6" },
        { text: $t("NiMHList.Columns.Unit7"), value:"unit7" },
        { text: $t("NiMHList.Columns.Temp1"), value:"temp1" },
        { text: $t("NiMHList.Columns.Temp2"), value:"temp2" },
        { text: $t("NiMHList.Columns.Temp3"), value:"temp3" },
        { text: $t("NiMHList.Columns.Temp4"), value:"temp4" }
      ],
      title: "",
      records: [],
      loading: true,
      isAutoUpdate: false,
      countDownTimer: 10,
      SystemStatusTime: "",
      SystemStatusOnOff: "",
      SystemStatusACDC: "",
      SystemStatusVolt: "",
      SystemStatusCurrent: "",
      SystemStatusEnergy: ""
    };
  },
  methods: {
    onClickUpdate() {
      this.isAutoUpdate = false;
      this.countDownTimer = 10;
      this.updateView();
    },
    onClickAutoUpdate() {
      this.isAutoUpdate = true;

      this.$root.currentTimer = setInterval(() => {
        if (!this.isAutoUpdate) {
          clearInterval(this.$root.currentTimer);
        }

        if (this.countDownTimer === 0) {
          this.updateView();
          this.countDownTimer = 10;
        } else {
          this.countDownTimer--;
        }
      }, 1000);
    },
    onClickStopUpdate() {
      this.isAutoUpdate = false;
      this.countDownTimer = 10;
    },
    onClickTop() {
      this.$router.push({ name: "top_page" });
    },
    updateView() {
      let vm = this;
      vm.axios
        .get(`${vm.$root.url}/Customer/NiMHStatus`, {
          headers: {
            Authorization: `Bearer ${vm.$root.token}`
          },
          params: {
            systemSn: this.$root.currentSerial.system
          }
        })
        .then(response => {
          vm.records = response.data;
          vm.loading = false;
          let dateString1 = response.data[0].systemStatusTime.split("T");
          let dateString2 = dateString1[0].split("-");
          vm.SystemStatusTime = dateString2[0]+"/"+dateString2[1]+"/"+dateString2[2]+"/ "+dateString1[1];
          vm.SystemStatusOnOff = response.data[0].systemStatusOnOff;
          vm.SystemStatusACDC = response.data[0].systemStatusACDC;
          vm.SystemStatusVolt = response.data[0].systemStatusVolt;
          vm.SystemStatusCurrent = response.data[0].systemStatusCurrent;
          vm.SystemStatusEnergy = response.data[0].systemStatusEnergy;
        })
        .catch(error => {
          vm.error = true;
          vm.result = "Error";
          vm.showResult = true;
          vm.loading = false;
        });
    }
  }
};
</script>

<style>

.dashboard2 {
  z-index: 9;
}

.dashboard2 .offset-sm3 {
  margin: 0 !important;
  flex-basis: 100% !important;
  max-width: 100% !important;
}

.v-table th{
  padding-left: 20px !important;
  background-color: #EEEEEE !important;
  color: black !important;
  font-size: 13px !important;
}

.h1_style{
  color: #483D8B;
  margin: 70px 0px 45px 0px;
  font-style: oblique;
	position: relative;
	padding: .3em;
	border-bottom: 1px solid #7986CB;
}
.h1_style::after {
	position: absolute;
	bottom: -3px;
	left: 0;
	z-index: 2;
	content: '';
	width: 18%;
	height: 5px;
	background-color: #303F9F;
}

.sys_style{
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: rgb(22, 135, 171);
}

</style>



// WEBPACK FOOTER //
// src/router/Customer/NimhStatus.vue